module.exports = __webpack_public_path__ + "static/21-04-02_13-12-28_4943-476ed0f079acaac506e4aded77b86940.png";